import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth';
import { map } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  let authService = inject(AuthService);
  let routerInject = inject(Router);

  return authService.isLoggedIn$.pipe(
    map(isLoggedIn => {
      console.log("IS LOGGED IN", isLoggedIn);
      return isLoggedIn || routerInject.createUrlTree(['/login']);
    })
  );
};
